// https://bit.ly/33cv2vn
const emailRegex = new RegExp(
  /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/ // eslint-disable-line
);

export const urlRegex = new RegExp(
  /(https?:\/\/)?([\w-])+\.{1}([a-zA-Z]{2,63})([/\w-]*)*\/?\??([^#\n\r]*)?#?([^\n\r]*)/
);

const prepValue = value => {
  if (typeof value === 'string') {
    value = value.replace(/[$,]*/g, '');
  }

  value = parseFloat(value) || 0;

  return value;
};

export const sum = values => {
  let result = 0;
  for (const value of values) {
    result += prepValue(value);
  }
  return result;
};

export const addCssClass = (element, className) => {
  if (element.classList) {
    element.classList.add(className);
  }
};

export const removeCssClass = (element, className) => {
  if (element.classList) {
    element.classList.remove(className);
  }
};

export const numberWithCommas = x => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const titleCase = string => {
  if (!string) return '';
  const sentence = string.toLowerCase().split(' ');
  for (let i = 0; i < sentence.length; i++) {
    sentence[i] = sentence[i][0].toUpperCase() + sentence[i].slice(1);
  }
  return sentence.join(' ');
};

export const popProperty = (obj, key) => {
  if (!obj || !key) {
    return '';
  }

  const copy = k => {
    if (!obj[k]) {
      return '';
    }

    if (Array.isArray(obj[k])) {
      return [...obj[k]];
    }

    return obj[k];
  };

  const keys = Array.isArray(key) ? key : [key];
  const values = keys.map(copy);
  keys.forEach(k => delete obj[k]);

  return values;
};

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',

  // These options are needed to round to whole numbers if that's what you want.
  minimumFractionDigits: 2, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  maximumFractionDigits: 2, // (causes 2500.99 to be printed as $2,501)
});

export const currencyFormat = num => formatter.format(num);

export const isValidEmail = email => {
  return emailRegex.test(email);
};

/**
 * Extract timestamp from id
 * @param flake {string}
 * @returns {number}
 */
export const extractTimestamp = flake => {
  // can't use bitwise shift on 64 bit integers
  const binaryStr = parseInt(flake).toString(2);
  return parseInt(binaryStr.substring(0, binaryStr.length - 22), 2);
};

export const simpleHash = str => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash &= hash; // Convert to 32bit integer
  }
  return new Uint32Array([hash])[0].toString(36);
};

export const replaceBars = function (str, lookup) {
  if (lookup) {
    const args = Object.keys(lookup);
    for (let key of args) {
      str = str.replace(new RegExp('\\{' + key + '\\}', 'gi'), lookup[key]);
    }
  }

  return str;
};

export const flatten = (obj, roots = [], sep = '.') =>
  Object.keys(obj).reduce(
    (memo, prop) =>
      Object.assign(
        {},
        memo,
        Object.prototype.toString.call(obj[prop]) === '[object Object]'
          ? flatten(obj[prop], roots.concat([prop]), sep)
          : { [roots.concat([prop]).join(sep)]: obj[prop] }
      ),
    {}
  );
